import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'

const elements = new WeakSet()
const parsed = new WeakMap()

export default element => {
  elements.add(element)
}

export const scope = element => {
  if (!parsed.has(element)) {
    const json = element.getAttribute('data-scope-json')
    const data = object(null, JSON.parse(json))
    
    if (!elements.has(element)) {
      return data
    }
    
    parsed.set(element, data)
  }
  
  return parsed.get(element)
}

export const scopeNode = (element, name) => {
  const fragment = element.closest(`[data-fragment="${name}"]`)
  return one('span[data-scope-json]', fragment)
}
